/**
 * Toggle Text on click
 * @module trimTotal
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import breaky from 'breaky';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'trimTotal';
// export const ACTIVE_CLASS = 'toggle-text--is-active';

export const DEFAULTS = {
  total: 0,
  elementToUpdate: 'order-history__img-overlay-text',
  elementContainer: '.order-history__img-container',
  overlayClass: 'order-history__img-overlay',
  totalShown: {tablet: 3, smallDesktop: 4, desktop: 5},
};

const addOverlay = (
  $el,
  elementToUpdate,
  elementContainer,
  overlayClass,
  totalHiddenNumber,
  childElementToSelect) => {
    const layoverMarkup = `<div class="${overlayClass}">
                              <p class="${elementToUpdate}">+${totalHiddenNumber}</p>
                          </div>`;
    $el.find(`${elementContainer}:nth-child(${childElementToSelect})`).append(layoverMarkup);
}

const removeOverlay = ($el, overlayClass) => {
  $el.find(`.${overlayClass}`).remove();
}

const makeUpdateImages = ($el, overlayClass, total, elementToUpdate, elementContainer) => (shown, breakpoint) => {
  removeOverlay($el, overlayClass);
  if(total > shown) {
    const elementWithOverlay = 1;
    const totalHiddenNumber = total - shown + elementWithOverlay;
    const childElementToSelect = shown;
    addOverlay($el, elementToUpdate, elementContainer, overlayClass, totalHiddenNumber, childElementToSelect);
  }
}

/**
 * Applies any event handlers to toggle text trigger
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

const updateTotalNumber = ($el,
  { total,
    elementToUpdate,
    elementContainer,
    overlayClass,
    totalShown
  }) => {

  const $elementToUpdate = $(elementToUpdate);
  const shownAtTablet = totalShown.tablet;
  const shownAtSmallDesktop = totalShown.smallDesktop;
  const shownAtDesktop = totalShown.desktop;
  let childElementToSelect = 0;
  const updateImage = makeUpdateImages($el, overlayClass, total, elementToUpdate, elementContainer);

  breaky.at("tablet", function() {
    updateImage(shownAtTablet, 'tablet');
  });
  breaky.at("small-desktop", function() {
    updateImage(shownAtSmallDesktop, 'small-desktop');
  });
  breaky.above("desktop", function() {
    updateImage(shownAtDesktop, 'desktop');
  });
};


/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function trimTotal(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  updateTotalNumber($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, trimTotal);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/trim-total.js